import React from 'react';
import { ListChecksIcon, MailIcon, PencilLineIcon, PlusIcon } from 'lucide-react';
interface ConditionsActionsProps {
  selectedCount: number;
}
const outlineBtn = 'inline-flex items-center gap-1.5 rounded-md border border-slate-300 bg-white px-3 py-1.5 text-sm font-medium text-brand transition-colors hover:bg-slate-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-not-allowed disabled:text-slate-400';
export function ConditionsActions({
  selectedCount
}: ConditionsActionsProps) {
  return <div className="flex flex-wrap items-center gap-2" data-id="element-118" data-mp="1yuc74jm0sz4a">
      <button type="button" className={outlineBtn} data-id="element-119" data-mp="1twao1yolgzst">
        <ListChecksIcon className="h-4 w-4" aria-hidden="true" data-id="element-120" data-mp="1tx3nsfp4yp1g" />
        Create Tasks
      </button>
      <button type="button" className={outlineBtn} data-id="element-121" data-mp="1ozk4309o5k24">
        <PlusIcon className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="1kwf5h8spm2ir" />
        Add Condition(s)
      </button>
      <button type="button" className={outlineBtn} disabled={selectedCount === 0} data-id="element-123" data-mp="1fwsruy8yyk9f">
        <PencilLineIcon className="h-4 w-4" aria-hidden="true" data-id="element-124" data-mp="1fiyhb5pfz29a" />
        Mass Update
      </button>
      <button type="button" className="inline-flex items-center gap-1.5 rounded-md bg-brand px-3 py-1.5 text-sm font-semibold text-white transition-colors hover:bg-brand-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-125" data-mp="1k956p7rs2qsl">
        <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="1y9fws8l9k1cp" />
        Send Conditions Email
      </button>
    </div>;
}